module.exports = __webpack_public_path__ + "img/20191022_122137.dda3c3b7.jpg";